import { format, parseISO } from 'date-fns'
import { IconType } from 'react-icons'
import { FiClipboard, FiDownload, FiMapPin, FiPlusCircle, FiUsers } from 'react-icons/fi'
import { ReleaseAnnouncementFeatureTheme, ReleaseAnnouncementPayload } from './types'

const ICON_REGISTRY: Record<string, IconType> = {
  users: FiUsers,
  clipboard: FiClipboard,
  'map-pin': FiMapPin,
  download: FiDownload,
  'plus-circle': FiPlusCircle,
}

const DEFAULT_THEME = {
  iconBg: 'gray.50',
  iconColor: 'gray.600',
}

export const WHATS_NEW_MODAL_FLAG_KEY = 'whats-new-modal'

export const getAnnouncementDismissKey = (id: string) => `announcement-${id}`

export const isAnnouncementPermanentlyDismissed = (id: string): boolean => {
  try {
    return window.localStorage.getItem(getAnnouncementDismissKey(id)) === 'true'
  } catch {
    return false
  }
}

export const persistAnnouncementPermanentDismiss = (id: string): void => {
  try {
    window.localStorage.setItem(getAnnouncementDismissKey(id), 'true')
  } catch {
    // storage unavailable (private browsing, quota, etc.)
  }
}

export const resolveFeatureIcon = (iconKey: string): IconType =>
  ICON_REGISTRY[iconKey] ?? FiPlusCircle

export const resolveFeatureTheme = (theme?: ReleaseAnnouncementFeatureTheme) => ({
  iconBg: theme?.iconBg ?? DEFAULT_THEME.iconBg,
  iconColor: theme?.iconColor ?? DEFAULT_THEME.iconColor,
})

export const formatPublishedAt = (publishedAt: string): string => {
  try {
    return format(parseISO(publishedAt), 'd MMM yyyy')
  } catch {
    return publishedAt
  }
}

export const isReleaseAnnouncementPayload = (
  value: unknown
): value is ReleaseAnnouncementPayload => {
  if (!value || typeof value !== 'object') return false

  const payload = value as ReleaseAnnouncementPayload

  return (
    typeof payload.id === 'string' &&
    typeof payload.publishedAt === 'string' &&
    !!payload.header &&
    typeof payload.header.badgeLabel === 'string' &&
    typeof payload.header.title === 'string' &&
    Array.isArray(payload.features) &&
    payload.features.length > 0 &&
    !!payload.footer &&
    typeof payload.footer.dismissCheckboxLabel === 'string' &&
    typeof payload.footer.primaryButtonLabel === 'string'
  )
}
